import { createAction, props } from '@ngrx/store';
import { Equipment } from '@polaris-customerweb/sharedcomponents.garage';

export enum EquipmentActionTypes {
    getEquipmentSuccess = '[Equipment] get equipment success',
    setActiveEquipmentId = '[Equipment] set active equipment',
    updateEquipment = '[Equipment] update equipment',
    updateEquipmentSuccess = '[Equipment] update equipment success',
    updateEquipmentFail = '[Equipment] update equipment fail',
    cancelUpdateEquipment = '[Equipment] cancel update equipment',
    deleteEquipment = '[Equipment] delete equipment',
    deleteEquipmentSuccess = '[Equipment] delete equipment success',
    deleteEquipmentFail = '[Equipment] delete equipment fail',
}

export const GetEquipmentSuccess = createAction(
    EquipmentActionTypes.getEquipmentSuccess,
    props<{ equipment: Equipment[] }>()
);

export const SetActiveEquipmentId = createAction(
    EquipmentActionTypes.setActiveEquipmentId,
    props<{ equipmentId: string }>()
);

export const UpdateEquipment = createAction(
    EquipmentActionTypes.updateEquipment,
    props<{ equipment: Equipment | undefined }>()
);

export const UpdateEquipmentSuccess = createAction(
    EquipmentActionTypes.updateEquipmentSuccess,
    props<{ equipment: Equipment }>()
);

export const UpdateEquipmentFail = createAction(
    EquipmentActionTypes.updateEquipmentFail,
    props<{ errorMessage: string }>()
);

export const CancelUpdateEquipment = createAction(
    EquipmentActionTypes.cancelUpdateEquipment
);

export const DeleteEquipment = createAction(
    EquipmentActionTypes.deleteEquipment,
    props<{ equipmentId: string }>()
);

export const DeleteEquipmentSuccess = createAction(
    EquipmentActionTypes.deleteEquipmentSuccess,
    props<{ equipmentId: string }>()
);

export const DeleteEquipmentFail = createAction(
    EquipmentActionTypes.deleteEquipmentFail,
    props<{ errorMessage: string }>()
);
